// Utility to normalize and trim strings

/**
 * Replaces typographic apostrophes and quotes with standard equivalents, and trims whitespace.
 * Handles: ’ → ', ‘ → ', “ → ", ” → ", and trims.
 */
export function normalizeAndTrim(str: string | undefined | null): string | undefined {
  if (str === undefined) return undefined;
  if (str === null) return '';
  return str
    .replace(/[’‘]/g, "'")
    .replace(/[“”]/g, '"')
    .trim();
}